
















































import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import SubscriptionSignup from "@/store/modules/SubscriptionSignup";

interface State {
  store: SubscriptionSignup;
  info: string;
  showInfo: boolean;
}

export default Vue.extend({
  name: "PayAsYouGoTotals",
  data(): State {
    return {
      store: getModule(SubscriptionSignup, this.$store),
      info: "",
      showInfo: false
    };
  },
  methods: {
    showConnectInfo() {
      this.info = `
       TeamBot Connect is a live video conferencing service.
       Usage is charged at $${this.store.selectedConnectPrice?.amount} per participant per minute.
       You are only billed for this service when you use it.
      `;
      this.showInfo = true;
    },
    showDataInfo() {
      this.info = `
       File storage in services like TeamBot Chat and TeamBot Academy will
       be billed back to your organization at $${this.store.selectedDataPrice?.amount} per GB per month.
       You are only billed for this service when you use it.
      `;
      this.showInfo = true;
    }
  }
});
